module.exports = __webpack_public_path__ + "media/images/brands/hankook-truck-masters/logo-ab8f4af819c583e3b8c912ec5cd31bb0.jpg";